import type { JSX } from 'react';
export function TomEco(): JSX.Element {
    return (
        <span>
            TOM
            <sup>eco</sup>
        </span>
    );
}
